/**
 * "Esta VM do job de backup ainda existe para o cliente?" (issue #795).
 *
 * Quem responde é o BACKEND, pelo campo `vm_removed` — a mesma régua
 * (`vm_visivel_no_portal`) que esconde a VM excluída do resto do portal. A régua vive lá
 * porque foi exatamente a cópia local que quebrou: a tela classificava por uma lista de
 * status escrita à mão, e a cópia dela nunca soube de `pending_deletion`. Resultado: a VM
 * em soft delete aparecia no job como VM viva, com o badge exibindo o status cru e o botão
 * de backup rápido ativo.
 *
 * O fallback por `vm_status` existe só para a **janela de deploy**: Cloudflare Pages e Fly
 * deployam separados, então esta tela conversa com a API antiga por alguns minutos e o
 * campo chega `undefined`. Lê-lo como "VM viva" faria o defeito voltar justamente nessa
 * janela — e agora com o clique batendo num 400 do backend novo.
 */

/** O mínimo que se precisa saber de uma VM de job para responder à pergunta. */
export type VMDeJobDeBackup = {
  vm_removed?: boolean
  vm_status?: string
}

/**
 * Status em que a VM já não existe para o cliente. Espelha `VM_STATUS_OCULTOS_DO_PORTAL`
 * do backend, mais dois status legados (`deleted`/`destroying`) que não existem no model
 * atual mas podem estar gravados em job antigo.
 */
const STATUS_DE_VM_REMOVIDA = new Set(['terminated', 'pending_deletion', 'deleted', 'destroying'])

export const isVMRemovida = (jobVM?: VMDeJobDeBackup): boolean =>
  jobVM?.vm_removed ?? STATUS_DE_VM_REMOVIDA.has(jobVM?.vm_status || '')
